import React from 'react';
import styled from 'styled-components';

const FooterContainer = styled.footer`
  background: #0a192f;
  padding: 20px 0;
  text-align: center;
  border-top: 1px solid rgba(100, 255, 218, 0.1);
`;

const Copyright = styled.p`
  color: #8892b0;
  font-size: 0.9rem;
  margin: 0;
`;

const NameLink = styled.a`
  color: #64ffda;
  text-decoration: none;
  position: relative;
  transition: all 0.3s ease;
  
  &:hover {
    color: #fff;
    
    &::after {
      width: 100%;
    }
  }
  
  &::after {
    content: '';
    position: absolute;
    bottom: -2px;
    left: 0;
    width: 0;
    height: 1px;
    background-color: #64ffda;
    transition: width 0.3s ease;
  }
`;

const Footer = () => {
  const currentYear = new Date().getFullYear();
  
  const scrollToTop = (e) => {
    e.preventDefault();
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  };
  
  return (
    <FooterContainer>
      <Copyright>
        &copy; {currentYear} <NameLink href="#" onClick={scrollToTop}>Isaac Naranjo</NameLink>
      </Copyright>
    </FooterContainer>
  );
};

export default Footer;
